export function mountCamera(container:HTMLElement,onPhoto:(file:File)=>void,onFile:(file:File)=>void){
 let stream:MediaStream|undefined,closed=false;
 const video=container.querySelector<HTMLVideoElement>('video')!;
 const capture=container.querySelector<HTMLButtonElement>('[data-camera=capture]')!;
 const message=container.querySelector<HTMLElement>('[data-camera=message]')!;
 const input=container.querySelector<HTMLInputElement>('[data-camera=file]')!;
 const stop=()=>{closed=true;stream?.getTracks().forEach(track=>track.stop());video.srcObject=null;};
 container.querySelector<HTMLButtonElement>('[data-camera=choose]')!.onclick=()=>input.click();
 input.onchange=()=>{const file=input.files?.[0];if(file){stop();onFile(file);}};
 capture.onclick=async()=>{
  if(!video.videoWidth||!video.videoHeight)return;
  capture.disabled=true;
  const scale=Math.min(1,2200/Math.max(video.videoWidth,video.videoHeight));
  const canvas=document.createElement('canvas');canvas.width=Math.round(video.videoWidth*scale);canvas.height=Math.round(video.videoHeight*scale);
  canvas.getContext('2d')!.drawImage(video,0,0,canvas.width,canvas.height);
  const blob=await new Promise<Blob|null>(resolve=>canvas.toBlob(resolve,'image/jpeg',0.94));
  if(closed)return;
  if(!blob){message.textContent='Não foi possível guardar a fotografia. Tente novamente.';capture.disabled=false;return;}
  const file=new File([blob],'fotografia-documento-'+new Date().toISOString().replace(/[:.]/g,'-')+'.jpg',{type:'image/jpeg'});
  stop();onPhoto(file);
 };
 void (async()=>{
  try{
   if(!navigator.mediaDevices?.getUserMedia)throw Object.assign(Error(),{name:'NotSupportedError'});
   const media=await navigator.mediaDevices.getUserMedia({video:{facingMode:{ideal:'environment'},width:{ideal:1920},height:{ideal:1080}},audio:false});
   if(closed||!video.isConnected){media.getTracks().forEach(track=>track.stop());return;}
   stream=media;video.srcObject=media;await video.play();
   if(closed)return;
   message.textContent='Enquadre o documento com boa luz. Confirme que os números se conseguem ler.';
   capture.disabled=false;
  }catch(error:any){
   stream?.getTracks().forEach(track=>track.stop());
   if(closed)return;
   message.textContent=error.name==='NotAllowedError'?'A câmara não foi autorizada. Pode permitir o acesso no navegador ou escolher um ficheiro.':error.name==='NotFoundError'?'Não foi encontrada uma câmara. Pode importar uma fotografia ou um PDF.':'Não foi possível abrir a câmara. Pode importar uma fotografia ou um PDF.';
  }
 })();
 return stop;
}
